"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataParser = /** @class */ (function () {
    function DataParser() {
    }
    DataParser.parseCompanyName = function (data) {
        if (data === void 0) { data = ''; }
        var res = data;
        res = DataParser.parseKabushikiGaisya(res);
        res = DataParser.toHankaku(res);
        return res;
    };
    /**
     * 数値を変換（半角にする。）
     * @param data
     */
    DataParser.parseTell = function (data) {
        if (data === void 0) { data = ''; }
        var res = data;
        res = DataParser.removeHyphen(res);
        res = DataParser.toHankaku(res);
        return res;
    };
    /**
     * ハイフンを除去（全角、半角）
     * 以下に対応！
     *
     * 文字 |UTF-8	 |Unicode	|説明
     * ------------------------------------
     * -    2D        U+002D    ASCIIのハイフン
     * ー   E383BC    U+30FC    全角の長音
     * ‐    E28090    U+2010    別のハイフン
     * ‑    E28091    U+2011    改行しないハイフン
     * –    E28093    U+2013    ENダッシュ
     * —    E28094    U+2014    EMダッシュ
     * ―    E28095    U+2015    全角のダッシュ
     * −    E28892    U+2212    全角のマイナス
     * ｰ    EFBDB0    U+FF70    半角カナの長音
     * @param data
     */
    DataParser.removeHyphen = function (data) {
        if (data === void 0) { data = ''; }
        return data.replace(/[-ー‐‑–—―−ｰ]/g, "");
    };
    DataParser.parseKabushikiGaisya = function (data) {
        if (data === void 0) { data = ''; }
        var res = data;
        DataParser.ILEGAL_KABUSHIKIKAISYA_LIST.forEach(function (ilegalKabushikikaisya) {
            res = res.replace(ilegalKabushikikaisya, DataParser.CORRECT_KABUSHIKIKAISYA);
        });
        return res;
    };
    /**
     * 半角カタカナを全角カタカナに変換
     * @param data
     */
    DataParser.parseKatakana = function (data) {
        if (data === void 0) { data = ''; }
        return data
            .replace(DataParser.KATAKANA_REGEX, function (match) {
            return DataParser.KATAKANA_MAP[match];
        })
            .replace(/ﾞ/g, '゛')
            .replace(/ﾟ/g, '゜');
    };
    /**
     * 英数字・記号を半角に変換
     * @param data
     */
    DataParser.toHankaku = function (data) {
        if (data === void 0) { data = ''; }
        // 入力値の全角を半角の文字に置換
        return data
            .replace(DataParser.ZENKAKU_REGEX, function (s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
        })
            .replace(/[‐－―]/g, "-") // ハイフンなど
            .replace(/[～〜]/g, "~") // チルダ
            .replace(/　/g, " "); // スペース
    };
    Object.defineProperty(DataParser, "KATAKANA_REGEX", {
        get: function () {
            return new RegExp('(' + Object.keys(DataParser.KATAKANA_MAP).join('|') + ')', 'g');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataParser, "ZENKAKU_REGEX", {
        get: function () {
            return /[Ａ-Ｚａ-ｚ０-９！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠［＼］＾＿｀｛｜｝]/g;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataParser, "ILEGAL_KABUSHIKIKAISYA_LIST", {
        get: function () {
            return [
                '㍿',
                '㈱',
                '(株)',
                '(株）',
                '（株)',
                '（株）',
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataParser, "CORRECT_KABUSHIKIKAISYA", {
        get: function () {
            return '株式会社';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataParser, "KATAKANA_MAP", {
        get: function () {
            return {
                'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
                'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
                'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
                'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
                'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
                'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
                'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
                'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
                'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
                'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
                'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
                'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
                'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
                'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
                'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
                'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
                'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
                'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
                '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
            };
        },
        enumerable: true,
        configurable: true
    });
    return DataParser;
}());
exports.default = DataParser;



//////////////////
// WEBPACK FOOTER
// ./common/src/utils/validation/data_parser.ts
// module id = T2dY
// module chunks = 1